import { SxProps } from "@mui/material";

export const EllipsesStyle: SxProps | undefined = {
    maxWidth: "150px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
}